import siteApiV2 from 'src/api/clients/site-v2';
import { Application } from '../../types/application';

export const fetchApplications = async (): Promise<Application[]> => {
  const { data } = await siteApiV2.get<{ applications: Application[] }>(
    '/applications',
  );

  return data.applications;
};
